import { render, staticRenderFns } from "./estimate-patient-cost-params.vue?vue&type=template&id=db7c5252&scoped=true"
import script from "./estimate-patient-cost-params.vue?vue&type=script&lang=js"
export * from "./estimate-patient-cost-params.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7c5252",
  null
  
)

export default component.exports